import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import { DemoConversationService } from '@forwardflow/services/DemoConversation'
import { DemoLead } from '@forwardflow/types/demo-conversation'
import useSWR from 'swr'
import { useMemo } from 'react'
import { transformApiResponseToLead } from '@forwardflow/helpers/utils/demoConversation'

export const useDummyLeads = (queryParams: any) => {
  const response = useSWR<any>(
    [QUERY_KEYS.DUMMY_LEADS, queryParams],
    () => DemoConversationService.getDummyLeads(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )

  const transformedData = useMemo(() => {
    if (!response.data) return []

    try {
      return response.data.map(transformApiResponseToLead)
    } catch (error) {
      console.error('Error transforming API response:', error)
      return []
    }
  }, [response.data])

  const { limit = 10, page = 1, stage } = queryParams || {}

  const processedData = useMemo(() => {
    const filteredData = stage
      ? transformedData.filter((lead: DemoLead) =>
        lead.stageInfo?.name?.toLowerCase() === stage.toLowerCase()
      )
      : transformedData

    const startIndex = (page - 1) * limit
    const paginatedData = filteredData.slice(startIndex, startIndex + limit)

    return {
      paginatedData,
      total: filteredData.length
    }
  }, [transformedData, stage, page, limit])

  return {
    data: processedData.paginatedData,
    total: processedData.total,
    loading: response.isLoading,
    error: response.error,
    mutate: response.mutate,
  }
}